import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitch, FaSpotify, FaHeart } from 'react-icons/fa';
import { HOME_TEXTS } from './constants';
import { ROUTES, APP_VERSION } from '../../config/constants';
import '../../styles/Home.css';

const CURRENT_YEAR = new Date().getFullYear();

/**
 * Composant de pied de page pour la page d'accueil
 * Affiche les informations de l'application, les crédits APIs et les liens légaux
 *
 * @component
 * @returns {JSX.Element} Le pied de page
 */
const HomeFooter = () => (
  <footer className="home-footer">
    <div className="footer-wave"></div>
    <div className="footer-content">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <FaTwitch className="footer-logo-icon twitch" />
            <span className="footer-logo-divider">/</span>
            <FaSpotify className="footer-logo-icon spotify" />
          </div>
          <span className="footer-brand-name">StreamingBot</span>
        </div>

        <div className="footer-apis">
          <span className="footer-api-badge twitch">
            <FaTwitch />
            <span>Twitch API</span>
          </span>
          <span className="footer-api-badge spotify">
            <FaSpotify />
            <span>Spotify API</span>
          </span>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        <p className="footer-made">
          Fait avec <FaHeart className="footer-heart" /> pour les streamers
        </p>
        <p className="footer-legal">
          © {CURRENT_YEAR} StreamingBot — {HOME_TEXTS.FOOTER.RIGHTS}.{' '}
          <Link to={ROUTES.MENTIONS_LEGALES} className="footer-link">
            {HOME_TEXTS.FOOTER.MENTIONS_LEGALES}
          </Link>
        </p>
        <p className="footer-version" title="Version en cours de développement">
          v{APP_VERSION}
        </p>
      </div>
    </div>
  </footer>
);

export default HomeFooter;
